import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function MessageBarPC(props) {
	const { classes, handleClose, getMsg } = props;

	if (props.msgConfig.open) {
		return (
			<Snackbar open={props.msgConfig.open} autoHideDuration={6000} onClose={handleClose}>
				<Alert onClose={handleClose} severity={props.msgConfig.severity} className={classes.messagerAlert}>
					{/* <div dangerouslySetInnerHTML={{ __html: getMsg() }} > */}
					<div>
						{Array.isArray(getMsg())
							? getMsg().map((msg) => {
									return <div>{msg}</div>;
								})
							: getMsg()}
					</div>
					{/* </div> */}
				</Alert>
			</Snackbar>
		);
	}
	return null;
}
